import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Emily Jones",
        title: "Network Specialist",
        biography: "Emily Jones is a skilled network specialist with in-depth expertise in Internet infrastructure and connectivity solutions. With extensive experience in setting up, maintaining, and troubleshooting network systems, she ensures seamless service delivery and optimal performance. Emily is passionate about helping clients stay connected with reliable and secure networks.",
        contacts: {
            phone: "333-444-5566",
            email: "emily.jones@example.com",
            website: "www.emilynetwork.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Lead Network Engineer - ConnectTech",
            "Internet Infrastructure Planner",
            "Residential and Commercial Installations",
            "Troubleshooting and Optimization",
            "Technical Support and Client Training"
        ],
        skills: [
            { id: 1, title: "Network Setup", progress: 94 },
            { id: 2, title: "Router Configuration", progress: 90 },
            { id: 3, title: "Troubleshooting", progress: 92 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Michael Smith",
        title: "Technical Lead",
        biography: "Michael Smith is a highly experienced technical lead specializing in system integration, troubleshooting, and digital infrastructure management. Known for his leadership and problem-solving skills, he oversees technical operations to ensure seamless service performance. Michael is dedicated to delivering reliable solutions and guiding teams through complex challenges.",
        contacts: {
            phone: "444-555-6677",
            email: "michael.smith@example.com",
            website: "www.michaeltechlead.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Technical Operations Manager - NetVision",
            "IT Systems Integration Lead",
            "Senior Network Troubleshooter",
            "Infrastructure Upgrade Supervisor",
            "Team Mentor and Coordinator"
        ],
        skills: [
            { id: 1, title: "System Integration", progress: 93 },
            { id: 2, title: "Tech Troubleshooting", progress: 95 },
            { id: 3, title: "Project Leadership", progress: 90 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Sarah Lee",
        title: "Sales Manager",
        biography: "Sarah Lee is a dynamic sales manager with a passion for building client relationships and driving business growth. With a proven track record in sales strategy and customer engagement, she leads her team to consistently exceed targets. Sarah is committed to delivering value through personalized service and innovative solutions.",
        contacts: {
            phone: "555-666-7788",
            email: "sarah.lee@example.com",
            website: "www.sarahsalespro.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Regional Sales Lead - MediaConnect",
            "Customer Engagement Strategist",
            "Retail & B2B Sales Expert",
            "Sales Training Coordinator",
            "Performance and Metrics Analyst"
        ],
        skills: [
            { id: 1, title: "Client Acquisition", progress: 91 },
            { id: 2, title: "Sales Strategy", progress: 94 },
            { id: 3, title: "Team Leadership", progress: 89 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "John Williams",
        title: "Support Head",
        biography: "John Williams leads the support department with a strong focus on customer satisfaction and operational efficiency. With extensive experience in managing technical support teams, John ensures swift issue resolution and continuous improvement in service quality. His leadership style emphasizes empathy, communication, and accountability.",
        contacts: {
            phone: "444-555-6677",
            email: "john.williams@example.com",
            website: "www.supportbyjohn.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Head of Customer Support - NetReach Solutions",
            "Technical Support Manager",
            "Client Relations Expert",
            "Helpdesk Operations Coordinator",
            "Support Policy Developer"
        ],
        skills: [
            { id: 1, title: "Customer Support", progress: 95 },
            { id: 2, title: "Team Management", progress: 90 },
            { id: 3, title: "Issue Resolution", progress: 93 }
        ]
    }

];

export default team;